import { Theme } from "@mui/material";

const MuiTabs = (theme: Theme, rootElement: HTMLElement) => ({
  defaultProps: {
    indicatorColor: "secondary",
    container: rootElement,
  },
});
export default MuiTabs;
